import { Partner } from "./types";

export const hkPartners: readonly Partner[] = [
  {
    id: "ocl",
    link: [
      { label: "(+852)2266 2222", href: "tel:+852-2266-2222" },
      {
        label: "WhatsApp",
        href: "https://api.whatsapp.com/send/?phone=85260377021&text=Text+Helen+to+start+a+conversation&type=phone_number&app_absent=0",
      },
    ],
    image: "ocl.png",
    opTime: "ocl_op_time",
    width: 90,
    height: 38,
    seeMoreLink: "ocl_see_more_link",
  },
];
